// Map backend errors from admin attendance endpoints to friendly Vietnamese strings.
// Spec: docs/admin-attendance-create-edit-history.md §7
//
// NOTE: Most BE messages are class-validator strings (not stable codes), so we
// match by substring. The only stable code is `ATTENDANCE_OVERLAP`.
// AxiosClient interceptor unwraps errors to `error.response.data`, so `err`
// here is typically `{ statusCode, message, error }`.

export function mapAttendanceError(err: any): string {
  const status: number | undefined = err?.statusCode || err?.status;
  const raw: string | undefined = Array.isArray(err?.message) ? err.message[0] : err?.message;

  if (raw === 'ATTENDANCE_OVERLAP') {
    return 'Giờ làm bị chồng chéo với bản ghi khác cùng ngày. Vui lòng kiểm tra lại.';
  }

  // Luật quyền (APPROVAL_*, thường là 409 — vd. tự sửa công của mình, cấp không được làm việc này):
  // máy chủ gửi kèm câu tiếng Việt ở `error`; đừng để rơi xuống "Xung đột dữ liệu." bên dưới.
  if (raw?.startsWith('APPROVAL_')) {
    const serverText = typeof err?.error === 'string' ? err.error.trim() : '';
    if (serverText && serverText !== raw) return serverText;
  }

  if (status === 401) return 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.';
  if (status === 403) return 'Bạn không có quyền thực hiện thao tác này.';

  if (status === 404) {
    if (raw?.includes('User')) return 'Không tìm thấy nhân viên. Vui lòng chọn lại.';
    if (raw?.includes('Shift')) return 'Ca làm không tồn tại.';
    if (raw?.includes('Attendance')) return 'Bản ghi chấm công không tồn tại hoặc đã bị xoá.';
    return 'Không tìm thấy dữ liệu.';
  }

  if (status === 409) {
    if (raw?.includes('already exists')) {
      return 'Đã có bản ghi chấm công cho user này, ca này, ngày này. Vào sửa thay vì tạo mới.';
    }
    return 'Xung đột dữ liệu.';
  }

  if (status === 400) {
    if (raw?.includes('YYYY-MM-DD')) return 'Định dạng ngày không hợp lệ.';
    if (raw?.includes('within current or previous month')) {
      return 'Chỉ có thể chấm công cho tháng hiện tại hoặc tháng trước.';
    }
    if (raw?.includes('checkoutTime') && raw?.includes('checkinTime')) {
      return 'Giờ checkout phải sau giờ checkin.';
    }
    if (raw?.includes('At least one of')) {
      return 'Vui lòng nhập giờ checkin hoặc checkout cần sửa.';
    }
    if (raw?.includes('Both checkinTime and checkoutTime')) {
      return 'Bản ghi thiếu giờ. Liên hệ kỹ thuật.';
    }
    if (raw?.includes('reason') && raw?.includes('500')) return 'Lý do tối đa 500 ký tự.';
    if (raw?.includes('reason') && raw?.includes('at least')) return 'Lý do tối thiểu 5 ký tự.';
    return raw || 'Dữ liệu không hợp lệ.';
  }

  if (status && status >= 500) return 'Lỗi server. Vui lòng thử lại sau.';
  return raw || 'Có lỗi xảy ra. Vui lòng thử lại.';
}
